import React from "react";
import { Link } from "react-router-dom";
import LoadJquery from "../helper/LoadJquery";
import AboutUs from "../components/Infra_Components/AboutUs";
import IndustriesWeServe from "../components/Infra_Components/IndustriesWeShare";
import CoreValues from "../components/Infra_Components/OurCoreSolutions";
import CardSection from "../components/Infra_Components/Para";
import InfrastructurePartners from "../components/Infra_Components/Partners";
import WhyChooseUs2 from "../components/Infra_Components/WhyChooseUs2";
import VisitorTracker from '../components/VisitorTracker';
import useContactForm from '../hooks/useContactForm';

const ITConsulting = () => {
  // Same shared hook as every other enquiry form on the site. The source page
  // name is what attributes the lead to IT Consulting in the admin console.
  const {
    errors, isLoading, handleSubmit, fieldProps,
  } = useContactForm("it-consulting");

  const Err = ({ name }) =>
    errors[name] ? (
      <p className="form-field-error" id={`${name}-error`} role="alert">
        <i className="fa-solid fa-circle-exclamation" aria-hidden="true" />{" "}
        {errors[name]}
      </p>
    ) : null;

   const cardStyle = {
  background: 'rgba(255, 255, 255, 0.9)',
  backdropFilter: 'blur(10px)',
  border: '1px solid rgba(0, 0, 0, 0.08)',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
  cursor: 'pointer',
  position: 'relative',
  overflow: 'hidden',
  minHeight : '150px',
  marginBottom : '30px'
};

const iconWrapperStyle = {
  width: '80px',
  height: '80px',
  background: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
  boxShadow: '0 8px 25px rgba(220, 38, 38, 0.3)',
  borderRadius: '18px',
  transition: 'all 0.3s ease',
  position: 'relative',
  overflow: 'hidden',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};

const shineStyle = {
  position: 'absolute',
  top: '-50%',
  left: '-50%',
  width: '200%',
  height: '200%',
  background: 'linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.2) 50%, transparent 70%)',
  transform: 'rotate(45deg)',
  transition: 'transform 0.6s ease'
};

const titleStyle = {
  color: '#1f2937',
  fontSize: '1.6rem',
  lineHeight: '1.3',
  fontFamily: '"Inter", "Segoe UI", sans-serif',
  letterSpacing: '-0.02em',
  marginBottom: '1rem'
};

const descriptionStyle = {
  color: '#6b7280',
  fontSize: '1.1rem',
  lineHeight: '1.7',
  margin: 0,
  fontWeight: '400',
  fontFamily: '"Inter", "Segoe UI", sans-serif'
};

const lineStyle = {
  width: '60px',
  height: '3px',
  background: 'linear-gradient(90deg, #dc2626, transparent)',
  marginTop: '20px',
  borderRadius: '2px'
};

 const renderIcon = (iconType) => {
    switch(iconType) {
      case 'chart':
        return (
          <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="10" y="25" width="7" height="20" fill="white" rx="2"/>
            <rect x="21" y="15" width="7" height="30" fill="white" rx="2"/>
            <rect x="32" y="10" width="7" height="35" fill="white" rx="2"/>
            <rect x="12" y="32" width="3" height="3" fill="#ffffff" rx="1" opacity="0.7"/>
            <rect x="23" y="22" width="3" height="3" fill="#ffffff" rx="1" opacity="0.7"/>
            <rect x="34" y="17" width="3" height="3" fill="#ffffff" rx="1" opacity="0.7"/>
          </svg>
        );
      
      case 'brain':
        return (
          <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M25 12C20 12 16 16 16 21v3c-2.5 0-4.5 2-4.5 4.5S13.5 33 16 33v4c0 5 4 8 9 8s9-3 9-8v-4c2.5 0 4.5-2 4.5-4.5S36.5 24 34 24v-3c0-5-4-9-9-9z" fill="white"/>
            <path d="M25 20l4-3M25 20l-4-3" stroke="#ffffff" strokeWidth="2" fill="none" opacity="0.8"/>
            <circle cx="22" cy="25" r="2" fill="#ffffff" opacity="0.6"/>
            <circle cx="28" cy="25" r="2" fill="#ffffff" opacity="0.6"/>
          </svg>
        );
      
      case 'handshake':
        return (
          <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 28h8l5 5h5l5-5h8l3 3v10l-3 3H15l-3-3v-10z" fill="white"/>
            <path d="M16 22l6 6h10l6-6" fill="white" opacity="0.8"/>
            <rect x="18" y="25" width="4" height="8" fill="#ffffff" rx="1" opacity="0.7"/>
            <rect x="28" y="25" width="4" height="8" fill="#ffffff" rx="1" opacity="0.7"/>
            <circle cx="14" cy="18" r="3" fill="white" opacity="0.9"/>
            <circle cx="36" cy="18" r="3" fill="white" opacity="0.9"/>
          </svg>
        );
      
      case 'network':
        return (
          <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="25" cy="25" r="5" fill="white"/>
            <circle cx="15" cy="15" r="4" fill="white" opacity="0.8"/>
            <circle cx="35" cy="15" r="4" fill="white" opacity="0.8"/>
            <circle cx="15" cy="35" r="4" fill="white" opacity="0.8"/>
            <circle cx="35" cy="35" r="4" fill="white" opacity="0.8"/>
            <circle cx="25" cy="10" r="3" fill="white" opacity="0.6"/>
            <circle cx="25" cy="40" r="3" fill="white" opacity="0.6"/>
            <line x1="18" y1="18" x2="22" y2="22" stroke="white" strokeWidth="2" opacity="0.7"/>
            <line x1="32" y1="18" x2="28" y2="22" stroke="white" strokeWidth="2" opacity="0.7"/>
            <line x1="18" y1="32" x2="22" y2="28" stroke="white" strokeWidth="2" opacity="0.7"/>
            <line x1="32" y1="32" x2="28" y2="28" stroke="white" strokeWidth="2" opacity="0.7"/>
            <line x1="25" y1="13" x2="25" y2="20" stroke="white" strokeWidth="2" opacity="0.7"/>
            <line x1="25" y1="30" x2="25" y2="37" stroke="white" strokeWidth="2" opacity="0.7"/>
          </svg>
        );
      
      case 'leaf':
        return (
          <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 35c0-10 5-15 10-20 5 5 10 10 10 20 0 5-5 10-10 10s-10-5-10-10z" fill="white"/>
            <path d="M25 15c3 3 5 8 5 13" stroke="#ffffff" strokeWidth="2" fill="none" opacity="0.7"/>
            <path d="M22 23c2 3 3 5 3 8" stroke="#ffffff" strokeWidth="2" fill="none" opacity="0.7"/>
            <circle cx="18" cy="30" r="2" fill="#ffffff" opacity="0.6"/>
            <circle cx="32" cy="32" r="2" fill="#ffffff" opacity="0.6"/>
            <path d="M20 37l-4 4M30 37l4 4" stroke="white" strokeWidth="2" opacity="0.8"/>
          </svg>
        );
      
      case 'target':
        return (
          <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="25" cy="25" r="18" fill="white"/>
            <circle cx="25" cy="25" r="12" fill="none" stroke="#ffffff" strokeWidth="2" opacity="0.8"/>
            <circle cx="25" cy="25" r="7" fill="none" stroke="white" strokeWidth="2" opacity="0.6"/>
            <circle cx="25" cy="25" r="3" fill="#ffffff" opacity="0.9"/>
            <line x1="10" y1="10" x2="15" y2="15" stroke="white" strokeWidth="2" opacity="0.7"/>
            <line x1="40" y1="10" x2="35" y2="15" stroke="white" strokeWidth="2" opacity="0.7"/>
            <line x1="10" y1="40" x2="15" y2="35" stroke="white" strokeWidth="2" opacity="0.7"/>
            <line x1="40" y1="40" x2="35" y2="35" stroke="white" strokeWidth="2" opacity="0.7"/>
          </svg>
        );
      
      default:
        return null;
    }
  };
  
  return (
    <div>
      <LoadJquery />
      <VisitorTracker page="it-consulting" />
      {/* tpm-header-area start */}
      {/* tpm-header-area end */}

      {/* tmp banner area start */}
      <div className="tmp-section-gap tmp-banner__agency-wrapper-bg position-relative bg_image">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="banner-inner-content-four">
                <div className="inner-content-banner-four">
                  {/* video icon */}
                  {/* <div
                    className="vedio-icone"
                    data-tmp-cursor="lg"
                    data-tmp-cursor-text="Play Video"
                  >
                    <Link className="video-play-button play-video" to="#">
                      <span></span>
                      <p className="text">Intro Vedio</p>
                    </Link>
                    <div className="video-overlay">
                      <Link className="video-overlay-close">×</Link>
                    </div>
                  </div> */}
                  {/* video icon */}
                  <div className="content-wrapper">
                    <h1 className="title">
                      We Provide Expert <br />IT Consulting Solutions
                    </h1>
                    <p className="disc">
                      Transform Your Digital Future With Our IT Consulting Expertise
                    </p>
                    <div className="button-area-banner-one">
                      <Link to="/contact" className="tmp-btn btn-primary">
                        <i className="fa-light fa-users"></i> Get In Touch With
                        Us
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="tmp-ocean">
          <div className="ocean">
            <div className="wave"></div>
            <div className="wave"></div>
          </div>
        </div>
      </div>


          {/*About Us Section  */}
          <AboutUs/>
          <IndustriesWeServe/>
          <CoreValues/>
          <CardSection/>
          

      {/* Start Testimonial with brand */}
      <div className="testimonial-with-brand">
        {/* Start Testimonial Area */}
        <div className="testimonial-brand-area">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div
                  className="testimonials-button-area"
                  style={{ marginTop: "70px" }}
                >
                  <div className="section-head text-align-left">
                    <h2 className="title split-collab">
                      What People Say About <br /> Our Company
                    </h2>
                  </div>

                  <div className="button-next-prev">
                    <div className="swiper-button-prev"></div>
                    <div className="swiper-button-next"></div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                {/* Slider main container */}
                <div className="swiper-style-one">
                  <div className="swiper-container-style-two">
                    {/* Additional required wrapper */}
                    <div className="swiper-wrapper">
                      <div className="swiper-slide">
                        {/* Card 1 */}
                    <div className="slider-card">
    <div className="d-flex align-items-start p-4 rounded-4 h-100" style={cardStyle}>
      <div className="me-4 flex-shrink-0">
        <div style={iconWrapperStyle}>
          <div style={shineStyle}></div>
          <div style={{ position: 'relative', zIndex: 2 }}>
            {renderIcon("chart")}
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <h3 style={titleStyle}>Projects delivered with desired outcomes</h3>
        <p style={descriptionStyle}>
          Program and project delivery teams, project controls processes and digital tools deliver greater analysis, schedule control and portfolio or program efficiency.
        </p>
        <div style={lineStyle}></div>
      </div>
    </div>
                        </div>
                      </div>


                      <div className="swiper-slide">
                     
                    {/* Card 2 */}
                      <div className="slider-card">
    <div className="d-flex align-items-start p-4 rounded-4 h-100" style={cardStyle}>
      <div className="me-4 flex-shrink-0">
        <div style={iconWrapperStyle}>
          <div style={shineStyle}></div>
          <div style={{ position: 'relative', zIndex: 2 }}>
            {renderIcon("brain")}
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <h3 style={titleStyle}>A safer, more efficient worksite</h3>
        <p style={descriptionStyle}>
          Increase visibility with digital construction management tools that connects workers, materials and machinery. Real-time monitoring of workers and assets increase field productivity and time on productive tasks.
        </p>
        <div style={lineStyle}></div>
      </div>
    </div>
                      </div>

                      </div>
                      <div className="swiper-slide">
                          {/* Card 3 */}
                  <div className="slider-card">
    <div className="d-flex align-items-start p-4 rounded-4 h-100" style={cardStyle}>
      <div className="me-4 flex-shrink-0">
        <div style={iconWrapperStyle}>
          <div style={shineStyle}></div>
          <div style={{ position: 'relative', zIndex: 2 }}>
            {renderIcon("handshake")}
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <h3 style={titleStyle}>Stronger synergy with contractors and consultants</h3>
        <p style={descriptionStyle}>
          Improve ecosystem performance by aligning on ways of working, tools and data sharing.
        </p>
        <div style={lineStyle}></div>
      </div>
    </div>
                    </div>
                      </div>
                      <div className="swiper-slide">
                       {/* Card 4 */}
                  <div className="slider-card">
    <div className="d-flex align-items-start p-4 rounded-4 h-100" style={cardStyle}>
      <div className="me-4 flex-shrink-0">
        <div style={iconWrapperStyle}>
          <div style={shineStyle}></div>
          <div style={{ position: 'relative', zIndex: 2 }}>
            {renderIcon("network")}
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <h3 style={titleStyle}>A supply chain that works for you</h3>
        <p style={descriptionStyle}>
          Boost supply chain efficiency by improving procurement spend, supplier relationships, logistics and transportation efficiency and inventory levels.
        </p>
        <div style={lineStyle}></div>
      </div>
    </div>
                   </div>
                      </div>
                    </div>
                    {/* If we need navigation buttons */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End Testimonial Area */}
        {/* <!-- progress area start --> */}
        <div className="progress-wrap">
          <svg
            className="progress-circle svg-content"
            width="100%"
            height="100%"
            viewBox="-1 -1 102 102"
          >
            <path
              d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
              style={{
                transition: "stroke-dashoffset 10ms linear 0s",
                strokeDasharray: "307.919, 307.919",
                strokeDashoffset: "307.919",
              }}
            ></path>
          </svg>
        </div>
        {/* <!-- progress area end --> */}
        {/* End Brand Area */}
      </div>
      <WhyChooseUs2/>
      <InfrastructurePartners/>
      {/* Enquiry form */}
      <div className="contact-area tmp-section-gap">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-5">
              <div className="section-head section-head-one-side text-align-left">
                <span className="title">Talk to an IT consultant</span>
                <p className="description">
                  Tell us what you are trying to modernise, migrate or secure. We reply
                  within one working day with a realistic scope, not a brochure.
                </p>
              </div>
              <ul className="ft-link ft-link-style-three">
                <li>
                  <div className="single-contact background-transparent">
                    <div className="icon"><i className="fa-light fa-phone"></i></div>
                    <div className="content">
                      <span>Call Us</span>
                      <Link className="contact-here" to="tel:+919057000445">
                        +91 90570 00445
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="single-contact background-transparent">
                    <div className="icon"><i className="fa-solid fa-envelope-open-text"></i></div>
                    <div className="content">
                      <span>E-mail</span>
                      <Link className="contact-here" to="mailto:info@starparth.com">
                        info@starparth.com
                      </Link>
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <div className="col-lg-7">
              <div className="contact-form style-two">
                <form id="contact-form" onSubmit={handleSubmit} noValidate>
                  <div className="contact-form-wrapper row">
                    <div className="form-honeypot" aria-hidden="true">
                      <input type="text" name="company_website" tabIndex={-1}
                        autoComplete="off" {...fieldProps("company_website")} />
                    </div>

                    <div className="col-lg-6">
                      <div className="form-group">
                        <input className="input-field" type="text" placeholder="Name"
                          autoComplete="name" {...fieldProps("name")} />
                        <Err name="name" />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <input className="input-field" type="tel" placeholder="Phone"
                          autoComplete="tel" {...fieldProps("phone")} />
                        <Err name="phone" />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <input className="input-field" type="email" placeholder="Email"
                          autoComplete="email" {...fieldProps("email")} />
                        <Err name="email" />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <input className="input-field" type="text"
                          placeholder="Website (optional)" {...fieldProps("website")} />
                        <Err name="website" />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group">
                        <textarea className="input-field" rows={5}
                          placeholder="What are you looking to solve?"
                          {...fieldProps("message")}></textarea>
                        <Err name="message" />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-submit-group">
                        <button type="submit" className="tmp-btn btn-gradiant-two"
                          disabled={isLoading}>
                          {isLoading ? "Sending\u2026" : "Submit Now"}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* End Testimonial with brand */}
    </div>
  );
};

export default ITConsulting;
